import { Howl } from 'howler';

export class EmbedComponent {
    constructor(element, episode, theme, marquee) {
        this.element = element;
        this.episode = episode;
        this.theme = theme;
        this.marquee = marquee;

        this.actualTime = 0;
        this.seek = 0;
        this.howler = null;
        this.timeInterval = null;
        this.isLoading = true;
        this.isPlaying = false;
        this.muted = false;
        this.rate = 1;
        this.speed_icon = 'icon-speed_1';
        this.totalTime = episode.length;

        this.render();

        this.setupHowler();

        if(this.marquee === "1") {
            this.setupMarquee();
        } else {
            this.element.querySelector("#episodeTitle").innerHTML = this.episode.title;
            this.element.querySelector("#episodeTitle").style.setProperty('white-space', 'unset');
            this.element.querySelector("#episodeTitle").setAttribute("title", this.element.querySelector("#episodeTitle").innerHTML);
            $clamp(document.getElementById("episodeTitle"), {clamp: 1});
        }
    }

    cover() {
        return "url(" + this.episode.storage_url + this.episode.image + ")";
    }

    render() {
        this.element.innerHTML = `
            <div id="player" class="${this.theme}">
                <div class="cover-container d-none d-sm-block">
                    <div style="background-image: ${this.cover()}" class="cover"></div>
                </div>
                <div class="player-container">
                    <h3>${this.episode.channel.title}</h3>
                    <h2 class="marquee" id="episodeTitle">
                        <div>${this.episode.title}</div>
                    </h2>
                    <div class="controls">
                        <div class="play-container">
                            <div class="play-button">
                                <span class="icon-play"></span>
                                <span class="icon-pause d-none"></span>
                            </div>
                        </div>
                        <div id="time-container" class="time-container">
                            <div class="time float-left">
                                0:00
                            </div>
                            <div class="time float-right">
                                0:00
                            </div>
                            <div id="seek-container">
                                <input id="seek-obj" type="range" name="rng" min="0" step="0.25" value="0" class="seek">
                            </div>
                            <div class="clearfix"></div>
                            <div class="actions noselect">
                                <i class="icon-volume_off d-none"></i>
                                <i class="icon-volume_up"></i>
                                <i class="ml-3 icon-replay_10"></i>
                                <i class="ml-3 icon-speed_1" id="changeSpeed"></i>
                                <i class="ml-3 icon-forward_30"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Add event listeners
        this.element.querySelector('.play-button').addEventListener('click', () => this.play());
        this.element.querySelector('.icon-volume_off').addEventListener('click', () => this.muteVolume());
        this.element.querySelector('.icon-volume_up').addEventListener('click', () => this.muteVolume());
        this.element.querySelector('.icon-forward_30').addEventListener('click', () => this.seekTo(30));
        this.element.querySelector('.icon-replay_10').addEventListener('click', () => this.seekTo(-10));
        this.element.querySelector('#seek-obj').addEventListener('input', () => this.seekToPos(this.element.querySelector('#seek-obj').value));

        this.element.querySelector('#changeSpeed').addEventListener('click', () => this.setRate());

        this.element.querySelector('.time.float-right').innerHTML = '-' + this.fancyTimeFormat(this.totalTime);
    }

    setupHowler() {
        this.howler = new Howl({
            src: this.episode.url + "/" + this.episode.audio.file,
            autoplay: false,
            loop: false,
            volume: 1,
            html5: true,
            preload: false,
            onload: () => {
                this.isLoading = false;
                this.totalTime = this.howler.duration();
            },
            onend: () => {
                this.isPlaying = false;
            },
            onpause: () => {
                this.isPlaying = false;
            },
            onstop: () => {
                this.isPlaying = false;
            },
            onplay: () => {
                this.isPlaying = true;
            },
            onloaderror: () => {
                this.isLoading = false;
                this.isPlaying = false;
                clearInterval(this.timeInterval);
            }
        });

        this.timeInterval = setInterval(() => {
            if(!this.seeking) {
                this.seek = this.howler.seek() / (this.howler.duration() / 100);
                this.actualTime = this.howler == null ? 0 : this.howler.seek();
                this.totalTime = this.howler.duration() == 0 ? this.totalTime : this.howler.duration() - this.howler.seek();

                if(!isNaN(this.seek)) {
                    this.element.querySelector("#seek-obj").value = this.seek;
                }

                this.element.querySelector('.time.float-left').innerHTML = this.fancyTimeFormat(this.actualTime);
                this.element.querySelector('.time.float-right').innerHTML = '-' + this.fancyTimeFormat(this.totalTime);
                this.element.querySelector(".time-container").style.setProperty('--seek-before-width', this.seek + '%');

                if(!this.isLoading) {
                    const node = this.howler._sounds[0]._node;
                    this.handleLoad(node);
                }
            }
        }, 100);
    }

    setupMarquee() {
        function isElementOverflowing(element) {
            var overflowX = element.offsetParent.offsetWidth < element.scrollWidth,
                overflowY = element.offsetParent.offsetHeight < element.scrollHeight;

            return (overflowX || overflowY);
        }

        var element = this.element.querySelector('#episodeTitle');

        if (isElementOverflowing(element)) {
            var childDiv = element.getElementsByTagName('div')[0];
            childDiv.classList.add("scrolling");
            element.innerHTML += childDiv.outerHTML;
            childDiv.innerHTML += "<span class='ml-4'>|</span>";
        }
    }

    seekToPos(seek) {
        this.seek = seek;
        this.howler.seek(this.howler.duration() * (seek/100));
    }

    play() {
        if(this.isPlaying) {
            this.howler.pause();
            this.element.querySelector('.icon-pause').classList.add('d-none');
            this.element.querySelector('.icon-play').classList.remove('d-none');
        } else {
            this.howler.play();
            this.element.querySelector('.icon-play').classList.add('d-none');
            this.element.querySelector('.icon-pause').classList.remove('d-none');
        }

        this.isPlaying = !this.isPlaying;
    }

    handleLoad(node) {
        if (this.howler.duration() > 0) {
            try {
                const bufferedAmount = Math.floor(node.buffered.end(node.buffered.length - 1));
                this.element.querySelector(".time-container").style.setProperty('--buffered-width', `${(bufferedAmount / this.howler.duration()) * 100}%`);
            } catch($e) {

            }
        }
    }

    fancyTimeFormat(duration) {
        var hrs = ~~(duration / 3600);
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;

        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    muteVolume() {
        if(this.muted) {
            this.howler.volume(1);
            this.element.querySelector('.icon-volume_off').classList.add('d-none');
            this.element.querySelector('.icon-volume_up').classList.remove('d-none');
        } else {
            this.howler.volume(0);
            this.element.querySelector('.icon-volume_up').classList.add('d-none');
            this.element.querySelector('.icon-volume_off').classList.remove('d-none');
        }

        this.muted = !this.muted;
    }

    seekTo(sec) {
        if(sec < 0) {
            if((this.howler.seek() + sec) < 0)  {
                sec = -this.howler.seek();
            }
        } else {
            if((this.howler.seek() + sec) > this.howler.duration()) {
                sec = this.howler.duration() - this.howler.seek();
            }
        }

        this.howler.seek(
            this.howler.seek() + sec
        );
    }

    setRate() {
        let rate = {'icon-speed_08': 0.8, 'icon-speed_1': 1, 'icon-speed_12': 1.2, 'icon-speed_15': 1.5, 'icon-speed_05': 0.5};
        let currentRate = rate[this.element.querySelector('#changeSpeed').classList[1]];

        switch(currentRate) {
            case 0.5:
                this.rate = 0.8;
                this.speed_icon = 'icon-speed_08';
                break;
            case 0.8:
                this.rate = 1;
                this.speed_icon = 'icon-speed_1';
                break;
            case 1:
                this.rate = 1.2;
                this.speed_icon = 'icon-speed_12';
                break;
            case 1.2:
                this.rate = 1.5;
                this.speed_icon = 'icon-speed_15';
                break;
            case 1.5:
                this.rate = 0.5;
                this.speed_icon = 'icon-speed_05';
                break;
        }

        this.element.querySelector('#changeSpeed').classList.remove(this.element.querySelector('#changeSpeed').classList[1]);
        this.element.querySelector('#changeSpeed').classList.add(this.speed_icon);
        this.howler.rate(this.rate);
    }

    url(path) {
        return window.location.origin + "/" + path;
    }
}
